// import Swiper JS
import Swiper, { Navigation, Pagination, Mousewheel,Autoplay } from 'swiper';


const $ = window.jQuery;

const popularSwiper = {
	init() {
		var $heroSwiper = $(document).find('.popularSwiperContainer');

		if (!$heroSwiper.length) return;

		// configure Swiper to use modules
		Swiper.use([Navigation, Pagination, Mousewheel, Autoplay]);

		

		if ($('body.page-template-template-vaning18')[0]) {
			const swiper = new Swiper('.popularSwiper', {
				slidesPerView: 1,
				spaceBetween: 20,
				loop: false,
				cache: true,
				infinit: false,
				lazy: true,
				autoplay: {
					delay: 6500,
					disableOnInteraction: false,
				},
				mousewheel: {
					forceToAxis: true,
				},
				breakpoints: {

				// when window width is >= 480px
				400: {
					slidesPerView: 1,
					spaceBetween: 20,
				},
				// when window width is >= 640px
				640: {
					slidesPerView: 2,
					spaceBetween: 20,
				},
				// when window width is >= 840px
				940: {
					slidesPerView:3,
					spaceBetween: 40,
				},
				1700: {
					slidesPerView: 4,
					spaceBetween: 40,
				},
				},
				navigation: {
					nextEl: '.swiper-button-next',
					prevEl: '.swiper-button-prev',
				},
		/* 		pagination: {
					el: '.swiper-pagination',
					clickable: true,
				}, */
			});
		} 
		
		if ($('body.page-template-default:not(.home)')[0]) {
			const swiper = new Swiper('.popularSwiper', {
				slidesPerView: 1.4,
				spaceBetween: 10,
				loop: false,
				cache: true,
				lazy: true,
				infinit: false,
				autoplay: {
					delay: 6500,
					disableOnInteraction: false,
				},
				mousewheel: {
					forceToAxis: true,
				},
				breakpoints: {

					// when window width is >= 480px
					420: {
						slidesPerView: 1.8,
						spaceBetween: 20,
					},
					// when window width is >= 640px
					640: {
						slidesPerView: 2,
						spaceBetween: 20,
					},
					// when window width is >= 840px
					940: {
						slidesPerView: 3,
						spaceBetween: 40,
					},
					1700: {
						slidesPerView: 4,
						spaceBetween: 40,
					},
				},
				navigation: {
					nextEl: '.swiper-button-next',
					prevEl: '.swiper-button-prev',
				},
				pagination: {
					el: '.swiper-pagination',
					clickable: true,
				},
			});
		} else  {

			const swiper = new Swiper('.popularSwiper', {
				slidesPerView: 1.4,
				spaceBetween: 10,
				loop: false,
				cache: true,
				lazy: true,
				infinit: false,
				autoplay: {
					delay: 6500,
					disableOnInteraction: false,
				},
				mousewheel: {
					forceToAxis: true,
				},
				breakpoints: {

					// when window width is >= 480px
					420: {
						slidesPerView: 1.8,
						spaceBetween: 20,
					},
					// when window width is >= 640px
					640: {
						slidesPerView: 2,
						spaceBetween: 20,
					},
					// when window width is >= 840px
					940: {
						slidesPerView: 3,
						spaceBetween: 40,
					},
					1700: {
						slidesPerView: 4,
						spaceBetween: 40,
					},
				},
				navigation: {
					nextEl: '.swiper-button-next',
					prevEl: '.swiper-button-prev',
				},
			/* 	pagination: {
					el: '.swiper-pagination',
					clickable: true,
				}, */
			});
		}


		
	},
};

export default popularSwiper;
